import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safeEmbedPipe',
})
export class SafeEmbedPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(videoUrl: string): SafeResourceUrl {
    const embedUrl = this.getVideoEmbedUrl(videoUrl);

    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl ?? videoUrl);
  }

  getVideoEmbedUrl(videoUrl: string): string {
    let videoId: string | null = null;
    let embedUrl: string | null = null;

    if (videoUrl.includes('youtube') || videoUrl.includes('youtu.be')) {
      videoId = this.extractVideoId(videoUrl, 'youtube');
      if (videoId) {
        embedUrl = `https://www.youtube.com/embed/${videoId}`;
      }
    } else if (videoUrl.includes('vimeo')) {
      videoId = this.extractVideoId(videoUrl, 'vimeo');
      if (videoId) {
        embedUrl = `https://player.vimeo.com/video/${videoId}`;
      }
    }

    return embedUrl || '';
  }

  private extractVideoId(url: string, platform: string): string | null {
    let videoId: string | null = null;

    try {
      if (platform === 'youtube') {
        const parsed = new URL(url);
        const host = parsed.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
          videoId = parsed.pathname.slice(1, 12) || null;
        } else if (
          host.endsWith('youtube.com') ||
          host.endsWith('youtube-nocookie.com')
        ) {
          if (parsed.searchParams.has('v')) {
            videoId = parsed.searchParams.get('v');
          } else {
            const match = parsed.pathname.match(
              /\/(?:embed|v|shorts|live)\/([a-zA-Z0-9_-]{11})/,
            );
            videoId = match ? match[1] : null;
          }
        }
      } else if (platform === 'vimeo') {
        const regex = /vimeo\.com\/(?:video\/)?(\d+)/;
        const matches = url.match(regex);
        videoId = matches ? matches[1] : null;
      }
    } catch {
      videoId = null;
    }

    if (!videoId) {
      console.error(
        `No se pudo extraer el ID de ${platform} de la URL: ${url}`,
      );
    }

    return videoId;
  }
}
